import Head from 'next/head'

import IndentedList from '../components/IndentedList'
import Layout from '../components/Layout'

export default function After(): JSX.Element {
  return (
    <Layout>
      <Head>
        <title>
          Robert Karasov - Minneapolis Mohel | What To Do After The Bris
        </title>
      </Head>
      <h1 className="mb-4 text-center text-2xl font-semibold">
        What To Do After The Bris
      </h1>
      <section className="space-y-4">
        <p>
          For 7 days following the bris, apply a 3"x3" gauze square that is
          coated with Vaseline or an antibiotic cream. This prevents the penis
          from sticking to the diaper which can cause bleeding. Wait 1 day to
          give the baby a bath.
        </p>
        <p>It is normal to see:</p>
        <IndentedList>
          <li>blood on the gauze for the first 1-2 days</li>
          <li>
            white or yellow sticky drainage on the head of the penis on the
            second or third day. This is not a sign of infection.
          </li>
          <li>mild redness and swelling for a week</li>
        </IndentedList>
        <p>
          If you see active bleeding, please apply pressure on the gauze for 5
          minutes. Call me if the bleeding doesn’t stop.
        </p>
        <p>
          The baby may be mildly fussy for the first 24 hours; however, Tylenol
          is usually not necessary.
        </p>
        <p className="font-bold">
          Feel free to call me with any questions. (952) 838-5042
        </p>
      </section>
    </Layout>
  )
}
